import {useEffect, useState} from "react";
import Loading from "../../component/Loading/Loading";
import {getAllReceipts, rejectReceipt, verifyReceipt} from "./functions";
import {PickDateTimeWithoutContainer} from "../../component/PickDate/PickDate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faCircleXmark} from "@fortawesome/free-solid-svg-icons";
import {toastSuccess} from "../../assets/functions";
import {useNavigate} from "react-router-dom";


const Receipts = () => {
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(true);
    const [allReceipts, setAllReceipts] = useState([]);

    useEffect(() => {

        (async () => {
            document.title = "رسید های واریز";
            const allReceipts = await getAllReceipts();
            console.log(allReceipts);
            setAllReceipts(allReceipts);
            setIsLoading(false);
        })();

    }, []);

    if (isLoading)
        return <Loading/>

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">رسید های بارگزاری شده</h1>
            </div>

            <div className="row">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className={"table text-center"}>
                                <thead>
                                <tr>
                                    <th width={"5%"}>ردیف</th>
                                    <th width={"5%"}>آیدی</th>
                                    <th width={"15%"}>زمان آپلود</th>
                                    <td>تصویر</td>
                                    <th>آیدی مشتری</th>
                                    <th>نام مشتری</th>
                                    <th>شماره تماس مشتری</th>
                                    <th>وضعیت</th>
                                    <th width={"5%"}>تایید</th>
                                    <th width={"5%"}>رد</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    allReceipts.map((receipt, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{receipt.id}</td>
                                                <td><PickDateTimeWithoutContainer timestamp={receipt.insertedTimestamp}
                                                                                  disabled={true}/></td>
                                                <td>
                                                    <img src={receipt.picture} width={200} height={200} />
                                                </td>

                                                <td>{receipt.customerId}</td>

                                                <td>
                                                    {receipt.person.firstname + " " + receipt.person.lastname}
                                                </td>

                                                <td>
                                                    {receipt.person.activePhonenumber}
                                                </td>

                                                <td>
                                                    {receipt.status.status == "INSERT" && <span className={"text-danger"}>بررسی نشده</span>}
                                                    {receipt.status.status == "REJECTED" && <span className={"text-danger"}>رد شده</span>}
                                                    {receipt.status.status == "VERIFIED" && <span className={"text-success"}>تایید شده</span>}
                                                </td>

                                                <td>
                                                    <button className={"btn btn-success"} onClick={async () => {
                                                        try {
                                                            const text = await verifyReceipt(receipt.id);
                                                            toastSuccess(text);
                                                            navigate(0);
                                                        }
                                                        catch (e){
                                                            toastSuccess("خطا در ویرایش وضعیت تراکنش");
                                                        }
                                                    }}>
                                                        <FontAwesomeIcon icon={faCheck} />
                                                    </button>
                                                </td>

                                                <td>
                                                    <button className={"btn btn-danger"} onClick={async () => {
                                                        try {
                                                            const text = await rejectReceipt(receipt.id);
                                                            toastSuccess(text);
                                                            navigate(0);
                                                        }
                                                        catch (e){
                                                            toastSuccess("خطا در ویرایش وضعیت تراکنش");
                                                        }
                                                    }}>
                                                        <FontAwesomeIcon icon={faCircleXmark} />
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Receipts;